<div class="ogp-flex-space">
  <atr-step-indicator [stepsData]="stepsData" (getSelectedTab)="onSelectedTabReceive($event)" [activeTab]="stepsData.activeId" [currentIndex] = "currentIndex" ></atr-step-indicator>
  <div class="ogp-btn" *ngIf="ictItems.length > 1">
    <art-save-zip [saveAsInfo]="{btnName:'Download all ICTs (.zip)', fileName:'jsonData'}" [ictItems]="ictItems" class="width-full">
    </art-save-zip>
  </div>
</div>
<div class="usa-media-block ogp-flex-space">
  <div class="ogp-btn">
    <button (click)="onAmendForm(currentIndex)" class="ogp-btn usa-button usa-button--outline float-right">Return to Form</button>
  </div>
  <div class="ogp-btn">
    <button type="" class="usa-button usa-button--accent-warm" (click)="copyToClipboard()">Copy All 508 Standards Language</button>
  </div>
  <div class="ogp-btn">
    <art-docx-download [params]="{btnName:'Save as word (.docx)', fileName:'Language'}" [markup]="languageGeneratedDoc[currentIndex]" ></art-docx-download>
  </div>
  <div class="ogp-btn">
    <art-save-json [saveAsInfo]="{btnName:'Save (.json)', fileName:'jsonData.json'}" [ictItem]="ictItems[currentIndex]" class="width-full" ></art-save-json>
  </div>
</div>
  
<div class="grid-row grid-gap margin-top-4">
  <main class="usa-layout-docs__main desktop:grid-col-12 usa-prose usa-layout-docs">
    <h2 class="site-preview-heading">Section 508 Requirements for Your Solicitation</h2>
    <section id="section-result">
      <div class="usa-summary-box" role="region" aria-labelledby="summary-box-key-information">
        <div class="usa-summary-box__body">
          <h3 class="usa-summary-box__heading">Why is this important?</h3>
            <p>
              By including Section 508 requirements in the solicitation, you are ensuring potential Offerors know which Section 508 standards apply to commercially available technology products required to be offered by the vendor in their proposals, as well as requirements to ensure technology services provided will support the agency’s ability to comply with the Section 508 law.
          </p>
          <h3 class="usa-summary-box__heading" id="summary-box-key-information">Instructions</h3>
          <div class="usa-summary-box__text">
            <p>Copy and paste the language below into your procurement (include in the SOW, PWS, or SOO)</p>
            <ol>
              <li>
                Include the Section 508 Requirements generated by ART in your Statement of Work, Performance Work Statement, or Statement of Objectives. These requirements apply to the specific technology products and services you are buying. <i>(do not copy these instructions into the solicitation)</i>.
              </li>
              <li>
                The ART output can be included as a separate document labeled as  your 508 requirements or as part of your requirements sections of your contract.
              </li>
              <li>
                If you copied and pasted Section 508 language from an earlier contract or solicitation, remove this old language in its entirety and replace it with the language generated by ART.
              </li>
              <li>
                Review the Section 508 requirements. If you have any questions about the requirements, contact your agency 508 program manager.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="example-spacing usa-prose margin-top-1 font-sans-sm">
      <h2 id="art-section-508-requirements">Section 508 Requirements</h2>
    </section>
    <section>
      <div id="results">
        <div class="section-1-results"></div>
      </div>
      <div id="copy-requirements">
        <p>
            Section 508 of the Rehabilitation Act, as amended by the Workforce Investment Act of 1998 (P.L. 105-220) requires that when Federal agencies
            develop, procure, maintain, or use information and communication technology (ICT), it shall be accessible to people with disabilities. Federal employees and
            members of the public who have disabilities must have access to, and use of, information and data that is comparable to people without disabilities.
        </p>
        <p *ngIf="ictItems[currentIndex] && ictItems[currentIndex].name">
            <b>Item that contains ICT: </b>{{ictItems[currentIndex].name}}
        </p>
        <div [innerHTML]="languageGeneratedUI[currentIndex]" class="margin-bottom-5">
          
        </div>
      </div>
    </section>
  </main>
</div>

<div class="usa-media-block ogp-flex-space">
  <div class="width-full">
    <button class="ogp-btn usa-button usa-button--base" (click)="onPrevious()" [disabled]="currentIndex==0">Previous ICT</button>
    <button class="ogp-btn usa-button usa-button--base" (click)="onNext()" [disabled]="currentIndex==maxIndex">Next ICT</button>
  </div>
 
  <!-- <div class="width-full">
    <button type="" class="ogp-btn usa-button usa-button--outline float-right margin-right-0" (click)="onAmendForm(currentIndex)">Amend Form</button>
  </div> -->
</div>

